export interface ArchivePoint {
  _id: { $oid: string };
  topic: string;
  siteId: string;
  parentDeviceType?: string;
  parentDeviceId?: string;
  deviceType?: string;
  deviceId?: string;
  pointName: string;
  dataType: string;
  isParsed: boolean;
}

export interface ArchivistPaginationResponse {
  data: ArchivePoint[];
  total_count: number;
}

export interface ArchivistDistinctResponse {
  data: string[];
}

export enum archiveFields {
  topic = 'topic',
  siteId = 'siteId',
  parentDeviceType = 'parentDeviceType',
  parentDeviceId = 'parentDeviceId',
  deviceType = 'deviceType',
  deviceId = 'deviceId',
  pointName = 'pointName',
  dataType = 'dataType',
}

export interface DistinctValuesParams {
  query_field?: string;
  multi_field?: string[];
  filters?: filterObject[];
}

export interface PaginatedSearchParams {
  page?: number;
  page_size?: number;
  search?: string;
  specify?: string;
  filters?: filterObject[];
}

export interface filterObject {
  field: string;
  value: string;
}
